<ng-container *ngIf="type === 'user'">

  <div *ngIf="!isImageSelected" class="position-relative">
    <img src="{{editedImage}}" alt="" class="img-fluid w-100 rounded-5" />
    <div class="d-flex justify-content-between position-absolute bottom-0 pb-3 pe-3 ps-3 w-100">
      <button *ngIf="canDelete" (click)="onDeleteClick()" type="button" class="btn btn-sm rounded-pill btn-danger">
        <i class="ai-trash"></i>
      </button>

      <label class="btn btn-sm rounded-pill btn-info btn-input">
        <i class="ai-camera"></i>
        <input #imageUpload (change)="imageSelected($event)" type="file" accept=".gif, .jpeg, .jpg, .png">
      </label>
    </div>
  </div>

  <div *ngIf="isImageSelected">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
      [resizeToWidth]="500" format="png" [cropperMinWidth]="100" (imageCropped)="imageCropped($event)"></image-cropper>
    <div class="d-flex justify-content-between mt-2">
      <button type="button" class="btn btn-sm rounded-pill btn-secondary" (click)="onCancelClick()"><i
          class="ai-trash me-2"></i>Anuleaza</button>
      <button type="button" class="btn btn-sm rounded-pill btn-info" (click)="onUploadClick()"><i
          class="ai-upload me-2"></i>Incarca</button>
    </div>
  </div>
</ng-container>



<ng-container *ngIf="type === 'event'">
  <div *ngIf="!isImageSelected" class="position-relative">
    <img src="{{editedImage}}" alt="" class="img-fluid w-100 rounded-5" />
    <div class="d-flex justify-content-between position-absolute bottom-0 pb-3 pe-3 ps-3 w-100">
      <button *ngIf="canDelete" (click)="onDeleteClick()" type="button" class="btn btn-sm rounded-pill btn-danger">
        <i class="ai-trash me-2"></i>Sterge
      </button>

      <label class="btn btn-sm rounded-pill btn-info btn-input">
        <i class="ai-camera me-2"></i>Selecteaza
        <input #imageUpload (change)="imageSelected($event)" type="file" accept=".gif, .jpeg, .jpg, .png">
      </label>
    </div>
  </div>

  <div *ngIf="isImageSelected">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="8 / 5"
      [resizeToWidth]="700" format="png" [cropperMinWidth]="100" (imageCropped)="imageCropped($event)"></image-cropper>
    <div class="d-flex justify-content-between mt-2">
      <button type="button" class="btn btn-sm rounded-pill btn-secondary" (click)="onCancelClick()"><i
          class="ai-trash me-2"></i>Anuleaza</button>
      <button type="button" class="btn btn-sm rounded-pill btn-info" (click)="onUploadClick()"><i
          class="ai-upload me-2"></i>Incarca</button>
    </div>
  </div>
</ng-container>
